import { createContext } from "react";

import type {
  IFormFieldContextValue,
  IFormItemContextValue,
} from "@/providers/formProvider/types";

export const FormFieldContext = createContext<IFormFieldContextValue>(
  {} as IFormFieldContextValue,
);

export const FormItemContext = createContext<IFormItemContextValue>(
  {} as IFormItemContextValue,
);
